/**
 * Module: Hero Swiper Slider
 * Description: Inizializza lo slider Swiper per la Hero della homepage.
 */

export default function initHeroSlider(selector = ".swiper-hero-slider") {
	if (typeof Swiper === "undefined") {
		console.warn("Swiper non disponibile per lo slider Hero!");
		return;
	}

	const sliders = document.querySelectorAll(selector);

	if (!sliders.length) {
		return;
	}

	sliders.forEach((slider, index) => {
		if (slider.swiper || slider.dataset.swiperInitialized === "true") {
			return;
		}

		const slidesCount = slider.querySelectorAll(".swiper-slide").length;

		if (!slidesCount) {
			return;
		}

		const hasManySlides = slidesCount > 1;
		const autoplayDelay = Number.parseInt(slider.dataset.swiperAutoplay, 10) || 5000;
		const speed = Number.parseInt(slider.dataset.swiperSpeed, 10) || 1000;
		const effect = slider.dataset.swiperEffect || "fade";
		const loop = slider.dataset.swiperLoop === "true" && hasManySlides;
		const pagination = slider.querySelector(".swiper-pagination-hero-slider");

		const wrapperId =
			slider.dataset.swiperWrapperId || `swiper-hero-slider-${index}`;

		const config = {
			slidesPerView: 1,
			spaceBetween: 0,
			loop,
			speed,
			effect,
			allowTouchMove: hasManySlides,
		};

		if (effect === "fade") {
			config.fadeEffect = {
				crossFade: true,
			};
		}

		if (hasManySlides) {
			config.autoplay = {
				delay: autoplayDelay,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			};

			if (pagination) {
				config.pagination = {
					el: pagination,
					clickable: true,
				};
			}
		}

		// Debug info in tabella
		console.log(`Inizializzazione Slider Hero [${index + 1}] 👍`);
		console.table({
			"ID": wrapperId,
			"Autoplay": `${autoplayDelay}ms`,
			"Velocità": `${speed}ms`,
			"Loop": loop,
			"Numero Slide": slidesCount,
			"Effetto": effect
		});

		new Swiper(slider, config);
		slider.dataset.swiperInitialized = "true";
	});
}
